import { TOKEN_SCOPE } from '@kc-console/context';

type ParsePathnameResponse = {
  /**
   * 메뉴 키워드 (ex) vpcs, projects, change-password
   * beyond-config-api를 호출하여 메뉴 데이터를 조회할 때 사용하는 정보
   */
  menuKeyword: string;
  /**
   * 메뉴 경로 (ex) /vpc/domain/subpath, /vpc/subpath
   * beyond-config-api를 호출하여 조회한 메뉴 데이터와 현재 접근한 경로를 매칭할 때 사용하는 정보
   */
  menuPath: string;
  /**
   * 서비스 라우트 경로 (ex) /vpcs, /vpcs/create, /subnets
   * beyond-config-api를 호출하여 조회한 메뉴 데이터와 현재 접근한 경로를 매칭할 때 사용하는 정보
   */
  routePath: string;
  /**
   * 서비스 키워드 (ex) iam, settings, vpc
   * beyond-config-api를 호출하여 서비스 데이터를 조회할 때 사용하는 정보
   */
  serviceKeyword: string;
};

/**
 * 1. ^: 문자열의 시작
 * 2. (\/[a-zA-Z0-9-]+): 첫 번째 캡처 그룹, /로 시작하고 영문자, 숫자, 하이픈으로 구성된 세그먼트
 * 3. (\/domain(?=\/|$)(\/[^\/]+)?|\/[^\/]+)?: 두 번째 캡처 그룹 (optional), /domain이 정확히 매치되고 (뒤에 /가 오거나 끝나는 경우) 선택적으로 하위 경로가 오거나, 일반적인 하나의 세그먼트
 */
// eslint-disable-next-line no-useless-escape
const pattern = /^(\/[a-zA-Z0-9-]+)(\/domain(?=\/|$)(\/[^\/]+)?|\/[^\/]+)?/;

/**
 * 입력된 경로가 패턴과 일치하면 매칭된 부분만 반환
 * 일치하지 않으면 원래 경로를 그대로 반환
 * ex 1) /virtual-machine/domain/subpath/ffffff -> /virtual-machine/domain/subpath
 * ex 2) /virtual-machine/subpath/ttt/aaa -> /virtual-machine/subpath
 * ex 3) /virtual-machine/test/domain/subpath -> /virtual-machine/test
 */
function trimPath(pathname: string): string {
  const match = pathname.match(pattern);
  return match ? match[0] : pathname;
}

export function parsePathname(pathname: string): ParsePathnameResponse {
  const menuPath = trimPath(pathname);
  const serviceKeyword = menuPath.split('/')[1] ?? '';
  const routePath = pathname.replace(`/${serviceKeyword}`, '');
  const withDomainPrefix = menuPath.startsWith(`/${serviceKeyword}/${TOKEN_SCOPE.DOMAIN}/`);
  const menuKeyword = withDomainPrefix ? menuPath.split('/')[3] : menuPath.split('/')[2];

  return {
    menuKeyword: menuKeyword ?? '',
    serviceKeyword: serviceKeyword ?? '',
    menuPath,
    routePath,
  };
}
